
export interface Paging {
    page: number;
    offset: number;
}
